import React from 'react'
import Hero from '../components/Hero'
import GlobalHiring from '../components/GlobalHiring'
import { contingent, headings } from '../data/GlobalHiringData'
import CardSection from '../components/CardSection'
import { featureContData_three } from '../data/CardSectionData'
import { featuresCont_three } from '../data/CardData'
import TextwithImage from '../components/TextwithImage'
import { textSections } from '../data/TextwithimageData'
import HireSection from '../components/HireSection'
import { hiringsectionincompany } from '../data/HiresectionData'
import { useNavigate } from 'react-router-dom'

const Contingent = () => {
  const navigate = useNavigate();
    const buttons = [
        { text: "Speak to an expert" , buttonClass: "companyFirstbutton"  }
      ];
  return (
    <>
    <Hero
      title="Contingent Workforce Management"
      description="With coverage across 40+ countries, we make it easy for you to engage and manage freelancers and contractors across the world while staying compliant with local employment laws and tax."
      buttonText="Connect with Expert"
      customClass="CompanyHiringBanner"
      imageSrc="/images/hero.png"
      squareColor="CompanyHiringsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
   <TextwithImage data={textSections.pagefourCont} />
    <GlobalHiring services={contingent} customClass='contingentservice' heading={headings.page2}/>
    <CardSection data={featureContData_three} featuress={featuresCont_three} customClass ='EorCard' />
    <TextwithImage data={textSections.pageContlist}/>
    <HireSection
        imageSrc={hiringsectionincompany.imageSrc}
        title={hiringsectionincompany.title}
        description={hiringsectionincompany.description}
        buttonText={buttons}
        className={hiringsectionincompany.className}
      />
    </>
  )
}

export default Contingent